/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type ISoftwareEscrowCreateMutationVariables = Types.Exact<{
  appId: Types.Scalars['ID']['input'];
  agreementForm: Types.AgreementFormEnum;
}>;

export type ISoftwareEscrowCreateMutation = {
  __typename?: 'Mutation';
  softwareEscrowCreate?: {
    __typename?: 'SoftwareEscrowCreatePayload';
    success: boolean;
    errors?: Array<string> | null;
    softwareEscrow?: { __typename?: 'SoftwareEscrow'; id: string } | null;
  } | null;
};

export const SoftwareEscrowCreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'softwareEscrowCreate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'appId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'agreementForm' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AgreementFormEnum' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'softwareEscrowCreate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'appId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'appId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'softwareEscrowCreateParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'agreementForm' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'agreementForm' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errors' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'softwareEscrow' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ISoftwareEscrowCreateMutation, ISoftwareEscrowCreateMutationVariables>;
